import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseCommandWithSettings } from '@shared/commands/base-command-with-settings';
import { Product } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { IRestrictionCommand, RestrictionCommandResult } from './restriction-command.interface';

@Injectable()
export abstract class BaseRestrictionCommand extends BaseCommandWithSettings<Product> implements IRestrictionCommand {
  abstract readonly type: string;
  abstract readonly title: string;
  abstract readonly icon?: string;
  abstract readonly isDangerous?: boolean;
  abstract readonly settingsNames?: string[];
  abstract readonly group?: string;

  constructor(
    protected override commandAvailabilityService?: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  /**
   * Проверка доступности команды ограничения с учетом серверных настроек
   */
  public isAvailable(context: { data: Product }): boolean {
    const additionalCheck = this.checkAvailability(context.data);

    // Используем базовую логику проверки серверных настроек
    const result = this.checkAvailabilityWithSettings(context.data, additionalCheck);

    // Для команд ограничений возвращаем только boolean (не Observable)
    if (result instanceof Observable) {
      // В данном случае для простоты возвращаем true,
      // но можно добавить синхронную проверку настроек
      console.warn('BaseRestrictionCommand: Observable result from settings check, returning true');

      return true;
    }

    return result;
  }

  /**
   * Дополнительные проверки доступности для конкретной команды ограничения
   */
  protected checkAvailability(_product: Product): boolean {
    return true;
  }

  /**
   * Выполнение команды ограничения
   */
  abstract execute(context: { data: Product }): Promise<RestrictionCommandResult>;
}
